// @flow

import './DesktopHeader.scss';

import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import type { HtmlRef } from '../../types';

type Props = {
  mainContentRef: HtmlRef,
  parentRef: HtmlRef
};

export const SkipMenuTabbing = ({ mainContentRef, parentRef }: Props) => {
  const history = useHistory();

  useEffect(() => {
    return history.listen(onUrlChange);
  }, [history]);

  const onUrlChange = () => focusOnRef(parentRef);

  const focusOnRef = (ref: HtmlRef): void => {
    if (ref.current) {
      ref.current.focus();
    }
  };

  return (
    <div
      onKeyDown={(e: SyntheticKeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
          focusOnRef(mainContentRef);
        }
      }}
      onClick={() => focusOnRef(mainContentRef)}
      tabIndex={0}
      className="c-skipMenuTabbing"
    >
      <p>Skip to main content</p>
    </div>
  );
};
